class ViewLayoutSwitch extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.buttons = Array.from(this.querySelectorAll('[data-value]'));
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setColumns(button.dataset.value));
    });
  }

  setColumns(value) {
    const grid = this.dataset.gridId ? document.getElementById(this.dataset.gridId) : null;
    const columnClass = this.columnClass(value);
    if (!grid || !columnClass) return;

    const pattern = this.columnClassPattern();
    Array.from(grid.classList).forEach((className) => {
      if (pattern.test(className)) grid.classList.remove(className);
    });
    grid.classList.add(columnClass);

    this.buttons.forEach((button) => {
      const isActive = button.dataset.value === String(value);
      button.classList.toggle('is--active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

  columnClass(value) {
    const suffix = {
      mobile: '-col',
      tablet: '-col-tablet',
      desktop: '-col-desktop',
    }[this.dataset.breakpoint];

    return suffix ? `grid--${value}${suffix}` : null;
  }

  columnClassPattern() {
    if (this.dataset.breakpoint === 'mobile') return /^grid--\d+-col$/;
    if (this.dataset.breakpoint === 'tablet') return /^grid--\d+-col-tablet$/;
    if (this.dataset.breakpoint === 'desktop') return /^grid--\d+-col-desktop$/;
    return /^$/;
  }
}

if (!customElements.get('view-layout-switch')) {
  customElements.define('view-layout-switch', ViewLayoutSwitch);
}
